export const PRIVACY_POLICY: string = 'PRIVACY_POLICY';
export const TERMS_AND_CONDITIONS: string = 'TERMS_AND_CONDITIONS';
